import { useStore } from "vuex";

export default {
    name: "StafetMailudsendelseList",
    props: {
        mailudsendelser: {
            type: Array,
            required: true
        }
    },
    setup(props) {
        const store = useStore();

        const openMailudsendelseOverlay = function(mailudsendelseId, e) {
            
            const mailudsendelse = props.mailudsendelser.find(m => m.id === mailudsendelseId)
            if(!mailudsendelse) return;

            store.commit('main/set_page_overlay_content_data', { type: "Stafet", mailudsendelse })
            store.dispatch('main/openPageOverlay', {
                overlayContent: "StafetMailEditorOverlay",
                returnTarget: e.currentTarget
            })
        }
        
        const getLabel = (labelKey) => store.getters['labels/getLabel']({
            labelCollection: 'StafetMailudsendelseList',
            labelKey
        })

        const formatDate = (date) => {
            if (!date) return getLabel('beingSentLabel');
            date = new Date(date);
            return date.toLocaleDateString('da-DK', { year: 'numeric', month: 'short', day: 'numeric' });
        }

        return {
            openMailudsendelseOverlay,
            formatDate,
            getLabel
        }
    }
}